<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col">
          <h6>Lista de leads</h6>
        </div>
        <div class="col">
          <button  class="btn bg-gradient-success float-end" @click="$router.push('/users-create')"> Crear lead</button>
          <button v-if="$userCan(['administrator','supervisor'])" class="btn bg-gradient-danger float-end me-2" @click="deactivateAll"> Desactivar todos</button>
        </div>
      </div>
    </div>
    <div class="card-body px-4">
      <div class="table-responsive">
        <div class="d-flex justify-content-between">
          <div class="w-25">
            <select name="per_page" id="per_page" v-model="pagination.limit" class="form-control" @click="reloadPaginate(1)">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
          <div class="w-25">
            <input type="text" class="form-control" placeholder="Escribí para buscar por correo o nombre" v-model="pagination.search" @keyup="manualSearch">
          </div>
        </div>
        <table class="table table-bordered table-sm">
          <thead>
          <tr>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nombre</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Correo</th>
            <th v-if="$userCan(['administrator','supervisor'])" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Agente asignado</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Opciones</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, key) in arrayUsers" :key="key">
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">{{item.name}}</p>
            </td>
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">{{item.email}}</p>
            </td>
            <td v-if="$userCan(['administrator','supervisor'])">
              <span
                v-if="item.assigned_agent_name"
                class="text-xs font-weight-bold"
              >
                {{ item.assigned_agent_name }}
              </span>
              <span v-else class="badge bg-danger text-white text-xs">
                Sin asignar
              </span>
            </td>
            <td>
              <span
                class="badge text-white text-xs"
                :class="item.status ? 'bg-success' : 'bg-danger'"
              >
                {{ item.status ? 'ACTIVO' : 'INACTIVO' }}
              </span>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{$filters.formatDate(item.created_at)}}</p>
            </td>
            <td>
              <button v-if="$userCan(['administrator'])" class="btn btn-danger btn-sm mb-0" @click="remove(item)">Cambiar estado</button>
              <button class="btn btn-success btn-sm mb-0" @click="view(item)">Ver</button>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between">
          <div>
            <p class="text-xs font-weight-bold mb-0">Filas totales: {{pagination.totalRows}}</p>
          </div>
          <div>
            <v-pagination
                v-model="pagination.page"
                :pages="pagination.pages"
                :range-size="1"
                active-color="#DCEDFF"
                @update:modelValue="reloadPaginate"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get, post} from "@/utils/httpRequest";


export default {
  name: "index",
  data: () => ({
    arrayUsers: [],
    pagination: {
      searchTimer: null,
      page: 1,
      pages: 0,
      limit: 10,
      search: '',
      totalRows: 0
    }
  }),
  mounted() {
    this.getData()
  },
  methods: {
    reloadPaginate(page){
      this.pagination.page = page
      this.getData()
    },
    manualSearch(){
      clearTimeout(this.pagination.searchTimer);
      this.pagination.searchTimer = setTimeout(() => {
        this.reloadPaginate(1)
      }, 2000);
    },

    async getData(){
      const {data} = await get(`users/find-all?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${this.pagination.search}`,null, true)
      this.arrayUsers = data.docs
      this.pagination.totalRows = data.count
      this.pagination.page = data.page
      this.pagination.pages = data.pages
    },
    async remove(item){
      this.$swal({
        html: '¿Estás seguro?',
        showCancelButton: true,
        confirmButtonText: 'SÍ',
        cancelButtonText: `NO`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await post("users/remove",{_id: item._id}, true)
          this.$swal({
            html: 'Proceso realizado con éxito',
            icon: 'success',
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
          await this.getData()
        }
      })
    },
    async deactivateAll(){
      this.$swal({
        html: '¿Está seguro de que desea DESACTIVAR TODOS los leads? Esta acción cambia el estado de todos a inactivo.',
        showCancelButton: true,
        confirmButtonText: 'SÍ, desactivar',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (!result.isConfirmed) return
        const {data} = await post('users/deactivate-all', {}, true)
        if(data && data.statusCode === 200){
          this.$swal({
            html: `Se desactivaron ${data.updated} lead(s)`,
            icon: 'success',
            timer: 2500,
            showCancelButton: false,
            showConfirmButton: false,
          });
          await this.getData()
        }else{
          this.$swal({
            html: (data && data.message) || 'Error',
            icon: 'error',
            timer: 2500,
            showCancelButton: false,
            showConfirmButton: false,
          });
        }
      })
    },
    view(item){
      this.$router.push({name: 'users-view', query: {id: item._id}})
    }
  }
}
</script>

<style scoped lang="scss">

</style>
